import gql from 'graphql-tag';

export const DEVICE_INFO = gql`
	query DeviceInfo {
		device {
			isBot
			botScore
		}
	}
`;
